import React from 'react'
import { Link, Redirect } from 'react-router-dom'
import axios from 'axios';
import DocumentMeta from 'react-document-meta';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faChevronLeft, faSearch, faPlus, faFilter } from '@fortawesome/free-solid-svg-icons'

import AppContext from '../../../AppContext.js';
import OffsetTop from '../../../components/offsetTop.js';

const localization = {
    ua: {
        title: 'Стемпінг',
        filter: {
            date: 'Дата'
        },
        searchText: 'Пошук...',
        noData: 'Данi вiдсутнi',
    },
    ru: {
        title: 'Стемпинг',
        filter: {
            date: 'Дата'
        },
        searchText: 'Поиск...',
        noData: 'Данi вiдсутнi',
    },
    en: {
        title: 'Stamping',
        filter: {
            date: 'Date'
        },
        searchText: 'Filter...',
        noData: 'Данi вiдсутнi',
    },
}

class MechanicStampingUpdate extends React.Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
		
		this.state = {
            isLoading: false,
            redirect: null,

            filterDate: null,

            kid: null,
            kitem: null,
            workOrderStartTime: null,
            workOrderFinishTime: null,
            workOrderType: null,
            workOrderNumber: null,
            workOrderName: null,

            mechanics: [],

            isOpen: false,

            mechanic: null,
            rows: []
        }

        this.dateToInputFormat= this.dateToInputFormat.bind(this);
        this.dateToDatabaseFormat= this.dateToDatabaseFormat.bind(this);

        this.changeDate= this.changeDate.bind(this);
        this.datePrev = this.datePrev.bind(this);
        this.dateNext = this.dateNext.bind(this);

        this.workOrderStartTimeChange = this.workOrderStartTimeChange.bind(this);
        this.workOrderFinishTimeChange = this.workOrderFinishTimeChange.bind(this);
        this.workOrderTypeChange = this.workOrderTypeChange.bind(this);
        this.workOrderNumberChange = this.workOrderNumberChange.bind(this);
        this.workOrderNameChange = this.workOrderNameChange.bind(this);

        this.save = this.save.bind(this);
    }

    componentDidMount() {
        const {lang, setMenuExpandText} = this.context;
        setMenuExpandText(localization[lang].title);

        this.setState({filterDate: Date.now()}, () => {
            this.loadList();
        });
    }

    dateToInputFormat(date) {
        var d = new Date(date);
        var month = '' + (d.getMonth() + 1);
        var day = '' + d.getDate();
        var year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
            
        if (day.length < 2) 
            day = '0' + day;

        return [year, month, day].join('-');
    }

    dateToDatabaseFormat(date) {
        var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        return [day, month, year].join('.');
    }

    databaseFormatToDate(date) {
        var d = date.split(".");
        return new Date(d[2], d[1] -1, d[0]);
    }

    changeDate(event) {
        this.setState({filterDate: new Date(event.target.value).getTime()}, () => {
            //this.loadList();
        });
    }

    datePrev() {
        this.setState({filterDate: this.state.filterDate - 86400000}, () => {
            //this.loadList();
        });
    }

    dateNext() {
        this.setState({filterDate: this.state.filterDate + 86400000}, () => {
            //this.loadList();
        });
    }
    
    searchTextKeyPress(e) {
        if (e.key === 'Enter') {
            e.target.blur();
        }
    }

    workOrderStartTimeChange(e) {
        this.setState({workOrderStartTime: e.target.value})
    }
    workOrderFinishTimeChange(e) {
        this.setState({workOrderFinishTime: e.target.value})
    }
    workOrderTypeChange(e) {
        this.setState({workOrderType: e.target.value})
    }
    workOrderNumberChange(e) {
        this.setState({workOrderNumber: e.target.value})
    }
    workOrderNameChange(e) {
        this.setState({workOrderName: e.target.value})
    }

    loadList() {
        const {addNotification, removeNotification, token} = this.context;
        
        var didF = this.props.match.params.did;
        var ditemF = this.props.match.params.ditem;
        var did = didF.substring(1);
        var ditem = ditemF.substring(1);

        if (process.env.NODE_ENV === 'production') {
            var u = addNotification("Завантаження...");
            axios.post('/api/service/mechanic/stamping/get', { 
                token: token, 
                did: did,
                ditem: ditem
            }).then((res) => {
                this.setState({
                    name: res.data.rows[0].name, 
                    workOrderStartTime: res.data.rows[0].workOrderStartTime, 
                    workOrderFinishTime: res.data.rows[0].workOrderFinishTime, 
                    hours: res.data.rows[0].hours, 
                    kid: res.data.rows[0].kid, 
                    kitem: res.data.rows[0].kitem, 
                    filterDate: this.databaseFormatToDate(res.data.rows[0].filterDate), 
                    workOrderType: res.data.rows[0].workOrderType, 
                    workOrderNumber: res.data.rows[0].workOrderNumber, 
                    workOrderName: res.data.rows[0].workOrderName,
                    isLoading: false
                });
                //console.log(filterDate)
                //console.log(this.state.filterDate)
                //console.log(this.dateToInputFormat(this.databaseFormatToDate(this.state.filterDate)))
                //console.log(this.state.rows[0].workOrderNumber)
            }).catch((error) => {
                addNotification(error.response.data, error.response.status);
            }).finally(function () {
                removeNotification(u);
            });
        } else {
            this.setState({
                isLoading: false,
                rows: [{
                    name: "Прогоріли шайби форсунок (ЗН 2300351)",
                    workOrderStartTime: "10:51:49",
                    workOrderFinishTime: "16:39:08",
                    hours: "5.78",
                    kid: 257,
                    kitem: 2,
                    filterDate: "17.02.2023",
                    workOrderType: 0,
                    workOrderNumber: "2300351",
                    workOrderName: "Прогоріли шайби форсунок"
                }
                ]
            });
        }
    }

    save() {
        const {addNotification, removeNotification, token} = this.context;

        var didF = this.props.match.params.did;
        var ditemF = this.props.match.params.ditem;
        var did = didF.substring(1);
        var ditem = ditemF.substring(1);
        did = parseInt(did);
        ditem = parseInt(ditem);
        var orderType = parseInt(this.state.workOrderType);

        if (process.env.NODE_ENV === 'production') {
            var u = addNotification("Завантаження...");
            axios.post('/api/service/mechanic/stamping/create', {
                token: token,
                kid: did,
                kitem: ditem,
                filterDate: this.dateToDatabaseFormat(this.state.filterDate),
                workOrderStartTime: this.state.workOrderStartTime,
                workOrderFinishTime: this.state.workOrderFinishTime,
                workOrderType: orderType,
                workOrderNumber: this.state.workOrderNumber,
                workOrderName: this.state.workOrderName
            }).then((res) => {
                this.setState({result: res.data.result, serror: res.data.serror});
                // if not serror
                if (res.data.result < 0){addNotification(res.data.serror, 2);}
                    else 
                    {this.setState({redirect: "/mechanic/stamping"});}
            }).catch((error) => {
                addNotification(error.response.data, error.response.status);
            }).finally(function () {
                removeNotification(u);
            });
            
        } else {
            var data = {
                token: token,
                kid: 0,
                kitem: 0,
                filterDate: this.dateToInputFormat(this.state.filterDate),
                workOrderStartTime: this.state.workOrderStartTime,
                workOrderFinishTime: this.state.workOrderFinishTime,
                workOrderType: this.state.workOrderType,
                workOrderNumber: this.state.workOrderNumber,
                workOrderName: this.state.workOrderName
            }
            console.log(data)
        }
    }

    render() {
        const {lang} = this.context;

        if (this.state.redirect !== null) {
            return <Redirect to={this.state.redirect} />
        }

        const meta = {
			title: localization[lang].title,
			description: localization[lang].title,
			meta: {
			  	charset: 'utf-8'
			}
        };

        if (this.state.isLoading) {
            return (
                <div>Loading...</div>
            );
        }

        return (
            <div>
                <DocumentMeta {...meta} />
                <OffsetTop submenu={false} />

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-10 offset-md-1">
                            <div className="container-fluid pl-0 pr-0">
                                <div className="row mb-3">
                                    <div className="col d-flex justify-content-between">
                                        <button className="btn-agis-light-outline" style={{height: "36px", width: "36px", minWidth: "36px"}} onClick={this.datePrev}><FontAwesomeIcon icon={faChevronLeft}/></button>
                                        <input type="date" className="form-control form-control-sm ml-2 mr-2" style={{height: "36px", borderRadius: "10px"}} onChange={this.changeDate} value={this.dateToInputFormat(this.state.filterDate)}/>
                                        <button className="btn-agis-light-outline" style={{height: "36px", width: "36px", minWidth: "36px"}} onClick={this.dateNext}><FontAwesomeIcon icon={faChevronRight}/></button>
                                    </div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col">
                                        <div className="card-agis pt-2 pb-2" style={{borderRadius: "15px"}}>
                                            <div className="row mt-2">
                                                <div className="col cs-form">
                                                    <input type="time" className="form-control" value={this.state.workOrderStartTime} onChange={this.workOrderStartTimeChange}/>
                                                </div>
                                                <div className="col cs-form">
                                                    <input type="time" className="form-control" value={this.state.workOrderFinishTime} onChange={this.workOrderFinishTimeChange}/>
                                                </div>
                                            </div>
                                            <div className="form-group mt-2 mb-2">
                                                <select className="form-control" id="exampleFormControlSelect1" value={this.state.workOrderType} onChange={this.workOrderTypeChange}>
                                                    <option value={0}>Робота</option>
                                                    <option value={1}>Простой</option>
                                                    <option value={2}>Інше</option>
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <input type="text" className="form-control" placeholder="Номер ЗН" value={this.state.workOrderNumber} onChange={this.workOrderNumberChange} />
                                                <input type="text" className="form-control mt-1" placeholder="Назва" value={this.state.workOrderName} onChange={this.workOrderNameChange} />
                                            </div>
                                            <div className="row d-flex justify-content-center mt-0 mb-3">
                                                <div className='col-6'>
                                                    <button onClick={this.save} className="btn-agis-primary mb-3 w-100">Зберегти</button>

                                                    <Link to={"/mechanic/stamping"} className="a-agis-light-outline w-100" style={{height: "36px"}}>
                                                        Назад до списку
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MechanicStampingUpdate;